function useCompanyData() {
  const focusProductsCategories = [
    "Processors",
    "Motherboards",
    "Memory",
    "HDD / SSD",
    "Software",
    "Graphics",
    "Peripherals / Accessories",
    "A-brand computers",
    "Smartphones / tablets",
    "Servers",
    "Network equipment",
    "Cybersecurity",
    "Audio-video conferencing",
    "Storage systems",
    "Digital signage"
  ];
  const cooperationTypes = [
    {
      id: "1",
      name: "Solution project implementation for core business growth"
    },
    {
      id: "2",
      name: "Hardware/Software request for quotation for further integration project"
    },
    {
      id: "3",
      name: "Distribution/resell of components/devices/software"
    },
    {
      id: "4",
      name: "Goods to be sold via Retail/e-tail store"
    },
    {
      id: "5",
      name: "Authorized Service Center"
    }
  ];
  const brands = [
    {
      id: "173245",
      name: "Accelstor"
    },
    {
      id: "173025",
      name: "AFOX"
    },
    {
      id: "170132",
      name: "AMD"
    },
    {
      id: "170313",
      name: "AOC"
    },
    {
      id: "170161",
      name: "Apple"
    },
    {
      id: "170158",
      name: "ASUS"
    },
    {
      id: "170105",
      name: "Canyon"
    },
    {
      id: "170383",
      name: "Crucial"
    },
    {
      id: "170192",
      name: "GIGABYTE"
    },
    {
      id: "173241",
      name: "Infinidat"
    },
    {
      id: "171538",
      name: "Infortrend"
    },
    {
      id: "14",
      name: "Intel"
    },
    {
      id: "173471",
      name: "IntelliFlash"
    },
    {
      id: "161101",
      name: "Kingston"
    },
    {
      id: "170177",
      name: "Lexmark"
    },
    {
      id: "170175",
      name: "Logitech"
    },
    {
      id: "172092",
      name: "Mellanox"
    },
    {
      id: "171945",
      name: "MikroTik"
    },
    {
      id: "173244",
      name: "Perenio"
    },
    {
      id: "170544",
      name: "PNY"
    },
    {
      id: "170168",
      name: "Prestigio"
    },
    {
      id: "170168",
      name: "Prestigio"
    },
    {
      id: "170950",
      name: "SanDisk"
    },
    {
      id: "170213",
      name: "Sapphire"
    },
    {
      id: "17",
      name: "Seagate"
    },
    {
      id: "170325",
      name: "Supermicro"
    },
    {
      id: "171077",
      name: "Synology"
    },
    {
      id: "42",
      name: "Toshiba"
    },
    {
      id: "42",
      name: "Toshiba"
    },
    {
      id: "170121",
      name: "Transcend"
    },
    {
      id: "170406",
      name: "Tyan"
    },
    {
      id: "171959",
      name: "Ubiquiti"
    },
    {
      id: "170130",
      name: "Western Digital"
    }
  ];
  const industries = [
    {
      id: "9",
      name: "AGRICULTURE",
      segments: [
        {
          id: "901",
          name: "Agronomy"
        },
        {
          id: "902",
          name: "Livestock farm"
        },
        {
          id: "903",
          name: "Other"
        }
      ]
    },
    {
      id: "15",
      name: "AUTOMOTIVE",
      segments: [
        {
          id: "1502",
          name: "Car Dealer"
        },
        {
          id: "1501",
          name: "Car Rental"
        },
        {
          id: "1503",
          name: "other"
        }
      ]
    },
    {
      id: "16",
      name: "BETTING",
      segments: [
        {
          id: "1602",
          name: "Betting Service Retailer"
        },
        {
          id: "1601",
          name: "Casino"
        },
        {
          id: "1603",
          name: "Online Betting"
        }
      ]
    },
    {
      id: "14",
      name: "COMMUNICATION",
      segments: [
        {
          id: "1827",
          name: "Media"
        },
        {
          id: "1812",
          name: "Print"
        },
        {
          id: "1402",
          name: "Radio Broadcasting"
        },
        {
          id: "1401",
          name: "TV Broadcasting"
        },
        {
          id: "1823",
          name: "Telco provider"
        }
      ]
    },
    {
      id: "10",
      name: "CONSTRUCTION",
      segments: [
        {
          id: "1001",
          name: "Construction Developer"
        }
      ]
    },
    {
      id: "19",
      name: "DATA CENTERS",
      segments: [
        {
          id: "301",
          name: "Data Center"
        },
        {
          id: "1804",
          name: "Internet Hosters"
        },
        {
          id: "1806",
          name: "Public Data Center"
        },
        {
          id: "1805",
          name: "Social Network Providers"
        }
      ]
    },
    {
      id: "4",
      name: "EDUCATION",
      segments: [
        {
          id: "1828",
          name: "High School"
        },
        {
          id: "404",
          name: "Pre-Primary Education"
        },
        {
          id: "403",
          name: "Private Schools"
        },
        {
          id: "402",
          name: "Public Schools"
        },
        {
          id: "405",
          name: "Sport school"
        },
        {
          id: "406",
          name: "Technical Secondary Education"
        },
        {
          id: "401",
          name: "University"
        },
        {
          id: "407",
          name: "other education"
        }
      ]
    },
    {
      id: "2",
      name: "FINANCIAL",
      segments: [
        {
          id: "201",
          name: "Commercial Banking"
        },
        {
          id: "204",
          name: "FX. Forex trader"
        },
        {
          id: "203",
          name: "Insurance"
        },
        {
          id: "202",
          name: "Investment Banking"
        },
        {
          id: "205",
          name: "Lawyers"
        },
        {
          id: "206",
          name: "Other"
        }
      ]
    },
    {
      id: "1",
      name: "GOVERNMENT",
      segments: [
        {
          id: "106",
          name: "Customs"
        },
        {
          id: "101",
          name: "Defence"
        },
        {
          id: "104",
          name: "Finance"
        },
        {
          id: "103",
          name: "International Affairs"
        },
        {
          id: "1808",
          name: "Judicial Institution"
        },
        {
          id: "107",
          name: "Labour Office"
        },
        {
          id: "102",
          name: "Police"
        },
        {
          id: "105",
          name: "Tax office"
        },
        {
          id: "108",
          name: "other Government"
        },
        {
          id: "1813",
          name: ""
        }
      ]
    },
    {
      id: "6",
      name: "HEALTHCARE",
      segments: [
        {
          id: "1809",
          name: "Dental Clinic"
        },
        {
          id: "603",
          name: "Hospitals"
        },
        {
          id: "1850",
          name: "Hygienic preparations"
        },
        {
          id: "602",
          name: "Medical Centers"
        },
        {
          id: "1851",
          name: "Optical"
        },
        {
          id: "601",
          name: "Pharmacutical"
        }
      ]
    },
    {
      id: "13",
      name: "HOSPITALITY",
      segments: [
        {
          id: "1847",
          name: "Exhibition hall"
        },
        {
          id: "1301",
          name: "Hotels"
        },
        {
          id: "1844",
          name: "Mall/Shoping center"
        },
        {
          id: "1302",
          name: "Restaturants, Caffee"
        },
        {
          id: "1303",
          name: "Spa Salon"
        },
        {
          id: "1814",
          name: "Tourism"
        },
        {
          id: "1826",
          name: "other"
        }
      ]
    },
    {
      id: "3",
      name: "IT SERVICES",
      segments: [
        {
          id: "302",
          name: "CSP. Cloud Service Provider"
        },
        {
          id: "306",
          name: "Call Service"
        },
        {
          id: "304",
          name: "ISP. Internet Service Provider"
        },
        {
          id: "303",
          name: "ISV. Software Vendor"
        },
        {
          id: "305",
          name: "IT Administration and Support"
        },
        {
          id: "307",
          name: "RMA Service"
        },
        {
          id: "308",
          name: "Technical Support"
        },
        {
          id: "309",
          name: "other"
        }
      ]
    },
    {
      id: "11",
      name: "MANUFACTURING",
      segments: [
        {
          id: "1830",
          name: "Automotive"
        },
        {
          id: "1840",
          name: "Chemicals"
        },
        {
          id: "1848",
          name: "Electro-mechanical"
        },
        {
          id: "1810",
          name: "Foodstuffs Production"
        },
        {
          id: "1837",
          name: "Medical"
        },
        {
          id: "1101",
          name: "Metalurgy"
        },
        {
          id: "1102",
          name: "Microelectronics"
        },
        {
          id: "1839",
          name: "Plastic Moulding"
        },
        {
          id: "1838",
          name: "Precission metal"
        },
        {
          id: "1841",
          name: "Textile"
        },
        {
          id: "1849",
          name: "Tobacco"
        },
        {
          id: "1103",
          name: "other"
        }
      ]
    },
    {
      id: "18",
      name: "PROFESSIONAL SERVICES",
      segments: [
        {
          id: "1002",
          name: "Architects"
        },
        {
          id: "1834",
          name: "Auditors and Tax Advisors"
        },
        {
          id: "1835",
          name: "Consulting Services"
        },
        {
          id: "1836",
          name: "Creative and Marketing Agencies"
        },
        {
          id: "1803",
          name: "Engineering Services"
        },
        {
          id: "1802",
          name: "Events Management"
        },
        {
          id: "1801",
          name: "Legal Services"
        }
      ]
    },
    {
      id: "5",
      name: "RETAIL TRADE",
      segments: [
        {
          id: "1818",
          name: "AAR. Apple Authorized Reseller"
        },
        {
          id: "1815",
          name: "APR. Apple Premium Reseller"
        },
        {
          id: "1825",
          name: "AV Integrator"
        },
        {
          id: "1846",
          name: "B2B"
        },
        {
          id: "1819",
          name: "B2C e-marketpalce"
        },
        {
          id: "502",
          name: "CE. Consumer Electornic"
        },
        {
          id: "1816",
          name: "Carrier. Telco Retail"
        },
        {
          id: "504",
          name: "DIY. Do It Yourself"
        },
        {
          id: "501",
          name: "FMCG"
        },
        {
          id: "1831",
          name: "Fashion"
        },
        {
          id: "1821",
          name: "Hi-Fi Specialist"
        },
        {
          id: "1845",
          name: "Luxury watches"
        },
        {
          id: "1817",
          name: "Mobile Retail"
        },
        {
          id: "1820",
          name: "Monobrand"
        },
        {
          id: "1842",
          name: "Pet Shops"
        },
        {
          id: "503",
          name: "e-Tailer"
        }
      ]
    },
    {
      id: "17",
      name: "SPORTING",
      segments: [
        {
          id: "1832",
          name: "Fitness Club"
        },
        {
          id: "1701",
          name: "Football Club"
        },
        {
          id: "1702",
          name: "Hockey Club"
        },
        {
          id: "1833",
          name: "Multi-purpose Arena"
        },
        {
          id: "1703",
          name: "Other"
        }
      ]
    },
    {
      id: "7",
      name: "TRANSPORTATION",
      segments: [
        {
          id: "704",
          name: "Airline"
        },
        {
          id: "707",
          name: "Airport"
        },
        {
          id: "705",
          name: "Ground fleet manageent"
        },
        {
          id: "1811",
          name: "Logistics"
        },
        {
          id: "701",
          name: "Public Transport"
        },
        {
          id: "703",
          name: "Sea Fleet Management"
        },
        {
          id: "706",
          name: "Sea port"
        },
        {
          id: "702",
          name: "Taxi company"
        },
        {
          id: "1843",
          name: "Trains"
        },
        {
          id: "708",
          name: "Warehousing"
        }
      ]
    },
    {
      id: "8",
      name: "UTILITIES",
      segments: [
        {
          id: "803",
          name: "Electicity"
        },
        {
          id: "1829",
          name: "Facilities Management and Cleaning"
        },
        {
          id: "802",
          name: "Gas"
        },
        {
          id: "801",
          name: "Oil"
        },
        {
          id: "804",
          name: "Sewerage"
        },
        {
          id: "805",
          name: "Telecom"
        }
      ]
    },
    {
      id: "20",
      name: "VIDEO SURVEILLANCE",
      segments: [
        {
          id: "1822",
          name: "Other"
        }
      ]
    },
    {
      id: "12",
      name: "WHOLESALE TRADE",
      segments: [
        {
          id: "1807",
          name: "Electronics"
        }
      ]
    }
  ];
  return {
    focusProductsCategories,
    cooperationTypes,
    brands,
    industries
  };
}
;
var useCompanyData_default = useCompanyData;
export {
  useCompanyData_default as default
};
